import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import Checkbox from "@material-ui/core/Checkbox"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import React, { useState } from "react"
import fields from "./WirelessLoggerFieldset"

export default function SimpleDialog({ selectedFields, open, onClose }) {
  const [checkedFields, setCheckedFields] = useState(selectedFields)

  return (
    <Dialog onClose={() => onClose(checkedFields)} open={open}>
      <DialogTitle>Select fields</DialogTitle>
      <List>
        {fields.map((field) => (
          <ListItem
            dense
            button
            onClick={() => {
              const { dataName } = field
              setCheckedFields((prev) =>
                prev.includes(dataName) ? prev.filter((item) => item !== dataName) : [...prev, dataName]
              )
            }}>
            <ListItemIcon>
              <Checkbox color="primary" checked={checkedFields.includes(field.dataName)} />
            </ListItemIcon>
            <ListItemText primary={field.head.selector ? field.head.selector() : field.head.render()} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  )
}
